export const admin_routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/admin/pages/Login"),
  },
  {
    path: "/SSO/:user_id",
    name: "UserLoginByAdmin",
    component: () => import("@/views/admin/pages/LoginByAdmin"),
  },
  {
    path: "/login-to-partner",
    name: "LoginToPartner",
    beforeEnter() {
      window.location.href = "https://partner.bimagrow.com/login";
    },
  },
  {
    path: "/become-partner",
    name: "BecomePartner",
    beforeEnter() {
      window.location.href = "https://partner.bimagrow.com/";
    },
  },
  {
    path: "/AgentLead/:id",
    name: "AgentLead",
    component: () => import("@/views/admin/pages/AgentLead"),
  },
  {
    path: "/addNewAgentLead/:agent_id",
    name: "AddNewAgentLead",
    component: () => import("@/views/admin/pages/AgentLead/addNewAgentLead"),
  },
  {
    path: "/agentAddNewLead/:agent_id",
    name: "AgentAddNewLead",
    component: () => import("@/views/admin/pages/AgentLead/NewForm"),
  },
  {
    path: "/employeeLead/:id",
    name: "EmployeeLead",
    component: () => import("@/views/admin/pages/EmployeeLead"),
  },
  {
    path: "/employeeAddNewLead/:employee_id",
    name: "EmployeeAddNewLead",
    component: () => import("@/views/admin/pages/EmployeeLeadNewForm"),
  },
  {
    path: "/leadNewListing",
    name: "LeadNewListing",
    component: () => import("@/views/admin/pages/AgentLead/leadNewListing"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/admin/pages/Login"),
  },
  {
    path: "/register",
    name: "AdminRegister",
    component: () => import("@/views/admin/pages/Register"),
  },
  {
    path: "/",
    component: () => import("@/views/admin/Layout"),
    meta: {
      middleware: "advisor-auth",
    },
    children: [
      // {
      //   path: "",
      //   name: "AdminDashboard",
      //   component: () => import("@/views/admin/pages/Dashboard"),
      // },
      {
        // path: "/dashboadNew",
        path: "",
        name: "AdminNewDashboard",
        component: () => import("@/views/admin/pages/DashboardNew"),
      },
      {
        path: "plans",
        name: "PlanListing",
        component: () => import("@/views/admin/pages/Plans/Index"),
      },
      {
        path: "payment",
        name: "RzPayment",
        component: () => import("@/views/admin/pages/Payment/Index"),
      },
      {
        path: "connects",
        name: "ConnectsListing",
        component: () => import("@/views/admin/pages/Connects/Index"),
      },
      {
        path: "lead",
        name: "LeadListing",
        component: () => import("@/views/admin/pages/Lead/Index"),
      },
      {
        path: "LeadNewView",
        name: "LeadNewView",
        component: () => import("@/views/admin/pages/Lead/LeadNewView"),
      },
      {
        path: "lead/vahan-view/:id",
        name: "LeadsVahanViewMore",
        component: () => import("@/views/admin/pages/Lead/LeadVahanView"),
      },
      {
        path: "newlead",
        name: "LeadNewListing",
        component: () => import("@/views/admin/pages/NewLead/Index"),
      },
      {
        path: "failedrenewaltolead/:id/:lob",
        name: "FailedRenewalConverttoLead",
        component: () =>
          import("@/views/admin/pages/Lead/FailedRenewalConverttoLead"),
      },
      {
        path: "newlead/create",
        name: "LeadNewAdd",
        component: () => import("@/views/admin/pages/NewLead/Create"),
      },
      {
        path: "Lead/create",
        name: "LeadAdd",
        component: () => import("@/views/admin/pages/Lead/Create"),
      },
      {
        path: "Lead/edit/:id",
        name: "LeadsEdit",
        component: () => import("@/views/admin/pages/Lead/Edit"),
      },
      {
        path: "lead/view/:id",
        name: "LeadsViewMore",
        component: () => import("@/views/admin/pages/Lead/View"),
      },
      {
        path: "lead/newpolicy/:id",
        name: "ConvertToNewPolicy",
        component: () => import("@/views/admin/pages/Lead/ConvertToNewPolicy"),
      },
      {
        path: "business",
        name: "BusinessListing",
        component: () => import("@/views/admin/pages/Business/Index"),
      },
      {
        path: "business/upload",
        name: "BusinessUpload",
        component: () => import("@/views/admin/pages/Business/Upload"),
      },
      {
        path: "business/new-upload",
        name: "BusinessNewUpload",
        component: () => import("@/views/admin/pages/Business/NewUpload"),
      },
      {
        path: "business/create",
        name: "BusinessAdd",
        component: () => import("@/views/admin/pages/Business/Create"),
      },

      // ========================================= BusinessMotorPolicy Start =========================================
      {
        path: "business/motor",
        name: "BusinessMotorListing",
        component: () =>
          import("@/views/admin/pages/Business/MotorPolicy/Index"),
      },
      {
        path: "business/createMotorPolicy/:id?",
        name: "BusinessMotorPolicyCreate",
        component: () =>
          import("@/views/admin/pages/Business/MotorPolicy/Create"),
      },

      {
        path: "business/motor/policy-listing",
        name: "BusinessPolicyMotorListing",
        component: () =>
          import("@/views/admin/pages/Business/PolicyBusinessMotor/Index"),
      },
      {
        path: "business/create/motor/policy/:id?",
        name: "BusinessPolicyMotorCreate",
        component: () =>
          import("@/views/admin/pages/Business/PolicyBusinessMotor/Create"),
      },

      // ========================================= BusinessMotorPolicy Start =========================================

      {
        path: "business/bulk",
        name: "BusinessBulkAdd",
        component: () => import("@/views/admin/pages/Business/Bulk/Index"),
      },
      {
        path: "business/excel",
        name: "BusinessExcelList",
        component: () => import("@/views/admin/pages/Business/Excel/Index"),
      },
      {
        path: "business/exceladd",
        name: "BusinessExcelAdd",
        component: () => import("@/views/admin/pages/Business/Excel/Create"),
      },
      {
        path: "business/exceledit/:id",
        name: "BusinessExcelEdit",
        component: () => import("@/views/admin/pages/Business/Excel/Edit"),
      },
      {
        path: "business/excelview/:id",
        name: "BusinessExcelView",
        component: () => import("@/views/admin/pages/Business/Excel/View"),
      },
      {
        path: "business/csvbulk",
        name: "BusinessCSVBulkAdd",
        component: () =>
          import("@/views/admin/pages/Business/Bulk/CsvImportPage.vue"),
      },
      {
        path: "business/view/:id",
        name: "BusinessView",
        component: () => import("@/views/admin/pages/Business/View"),
      },
      {
        path: "business/viewmore/:id",
        name: "BusinessViewMore",
        component: () => import("@/views/admin/pages/Business/viewmore"),
      },
      {
        path: "whatsapptemplate",
        name: "WhatsAppTemplate",
        component: () => import("@/views/admin/pages/Profile/Whatsapp"),
      },
      {
        path: "whatsappportalcred",
        name: "WhatsAppPortalCredentials",
        component: () => import("@/views/admin/pages/Profile/WhatsappPortalCred"),
      },
      {
        path: "whatsappportal",
        name: "WhatsAppPortal",
        component: () => import("@/views/admin/pages/Profile/WhatsappPortal"),
      },
      {
        path: "template",
        name: "TemplateListing",
        component: () => import("@/views/admin/pages/Template/Index"),
      },
      {
        path: "template/create",
        name: "TemplateAdd",
        component: () => import("@/views/admin/pages/Template/Create"),
      },
      {
        path: "template/edit/:id",
        name: "TemplateEdit",
        component: () => import("@/views/admin/pages/Template/Edit"),
      },
      {
        path: "template/view/:id",
        name: "TemplateView",
        component: () => import("@/views/admin/pages/Template/Views"),
      },
      {
        path: "master-vehicle-master",
        name: "MasterVehicleMasterListing",
        component: () =>
          import("@/views/admin/pages/Master/VehicleMaster/Index"),
      },
      {
        path: "master-vehicle-master/create",
        name: "MasterVehicleMasterAdd",
        component: () =>
          import("@/views/admin/pages/Master/VehicleMaster/Create"),
      },
      {
        path: "master-vehicle-master/create/:id",
        name: "MasterVehicleMasterEdit",
        component: () =>
          import("@/views/admin/pages/Master/VehicleMaster/View"),
      },
      // Branch
      {
        path: "branch",
        name: "BranchListing",
        component: () => import("@/views/admin/pages/Employee/Branch/Index"),
      },
      {
        path: "branch/create",
        name: "BranchAdd",
        component: () => import("@/views/admin/pages/Employee/Branch/Create"),
      },
      {
        path: "branch/edit/:id",
        name: "BranchEdit",
        component: () => import("@/views/admin/pages/Employee/Branch/Edit"),
      },
      // Department
      {
        path: "department",
        name: "DepartmentListing",
        component: () =>
          import("@/views/admin/pages/Employee/Department/Index"),
      },
      {
        path: "department/create",
        name: "DepartmentAdd",
        component: () =>
          import("@/views/admin/pages/Employee/Department/Create"),
      },
      {
        path: "department/edit/:id",
        name: "DepartmentEdit",
        component: () => import("@/views/admin/pages/Employee/Department/Edit"),
      },
      // Designation
      {
        path: "designation",
        name: "DesignationListing",
        component: () =>
          import("@/views/admin/pages/Employee/Designation/Index"),
      },
      {
        path: "designation/create",
        name: "DesignationAdd",
        component: () =>
          import("@/views/admin/pages/Employee/Designation/Create"),
      },
      {
        path: "designation/edit/:id",
        name: "DesignationEdit",
        component: () =>
          import("@/views/admin/pages/Employee/Designation/Edit"),
      },
      // Banks
      {
        path: "bank",
        name: "BankListing",
        component: () => import("@/views/admin/pages/Bank/Index"),
      },
      {
        path: "bank/create",
        name: "BankAdd",
        component: () => import("@/views/admin/pages/Bank/Create"),
      },
      {
        path: "bank/create/:id",
        name: "BankEdit",
        component: () => import("@/views/admin/pages/Bank/View"),
      },

      {
        path: "bankledger",
        name: "BankLedger",
        component: () => import("@/views/admin/pages/Bank/Ledger"),
      },
      {
        path: "ledgerbankview/:id",
        name: "LedgerBankView",
        component: () => import("@/views/admin/pages/Bank/Ledgerview"),
      },
      // Cash Ledger
      {
        path: "cashledger",
        name: "CashLedger",
        component: () => import("@/views/admin/pages/Bank/CashLedger"),
      },
      {
        path: "ledgercashview/:id",
        name: "LedgerCashView",
        component: () => import("@/views/admin/pages/Bank/LedgerCashview"),
      },
      // Agent
      {
        path: "agent",
        name: "AgentListing",
        component: () => import("@/views/admin/pages/Agent/Index"),
      },
      {
        path: "agent/bulkHistory",
        name: "AgentListingBulkHistory",
        component: () => import("@/views/admin/pages/Agent/BulkHistory"),
      },
      {
        path: "agent/create",
        name: "AgentAdd",
        component: () => import("@/views/admin/pages/Agent/Create"),
      },
      {
        path: "agent/create/:id",
        name: "AgentEdit",
        component: () => import("@/views/admin/pages/Agent/View"),
      },
      {
        path: "agent/view/:id",
        name: "AgentView",
        component: () => import("@/views/admin/pages/Agent/ViewAgent"),
      },
      {
        path: "group",
        name: "GroupListing",
        component: () => import("@/views/admin/pages/Group/Index"),
      },
      {
        path: "group/create",
        name: "GroupAdd",
        component: () => import("@/views/admin/pages/Group/Create"),
      },
      {
        path: "group/create/:id",
        name: "GroupEdit",
        component: () => import("@/views/admin/pages/Group/View"),
      },
      {
        path: "group/client",
        name: "ClientMemberList",
        component: () => import("@/views/admin/pages/Group/ClientList"),
      },
      {
        path: "/group/assignclientnewmotorpolicy/:id",
        name: "AssignClientNewMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Group/assignclientnewmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "/group/assignclientnewxmotorpolicy/:id",
        name: "AssignClientNewXMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Group/assignclientnewxmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "group/client/:id",
        name: "ClientGroupMemberList",
        component: () => import("@/views/admin/pages/Group/ClientList"),
      },
      {
        path: "group/membercreate",
        name: "ClientGroupMemberAdd",
        component: () => import("@/views/admin/pages/Group/MemberCreate"),
      },
      {
        // path: "group/membercreate/:GroupMemberId",
        path: "group/memberedit/:GroupMemberId",
        name: "ClientMemberEdit",
        component: () => import("@/views/admin/pages/Group/MemberEdit"),
      },
      {
        path: "group/member-view/:GroupMemberId",
        name: "ClientMemberView",
        component: () => import("@/views/admin/pages/Group/MemberView"),
      },
      {
        path: "group/member-vehicleinfoedit/:id/:GroupMemberId",
        name: "GroupMemberVehicleInfoEdit",
        component: () =>
          import("@/views/admin/pages/Group/VehicleInfoMemberEdit"),
      },
      {
        path: "member/df-view/:id",
        name: "MemberPDFView",
        component: () => import("@/views/admin/pages/Group/MemberPDFView"),
      },
      {
        path: "member/df--view/:id",
        name: "Member2PDFView",
        component: () => import("@/views/admin/pages/Group/Member2PDFView"),
      },

      {
        path: "group/membercreate/:id",
        name: "GroupMemberAdd",
        component: () => import("@/views/admin/pages/Group/MemberCreate"),
      },
      {
        path: "group/membercreate/:id/:GroupMemberId",
        name: "GroupMemberEdit",
        component: () => import("@/views/admin/pages/Group/MemberEdit"),
      },
      {
        path: "group/group-member-view/:id/:GroupMemberId",
        name: "GroupMemberView",
        component: () => import("@/views/admin/pages/Group/MemberView"),
      },
      {
        path: "group/view/:id",
        name: "GroupView",
        component: () => import("@/views/admin/pages/Group/newView"),
      },
      {
        path: "group/assetcreate/:id",
        name: "GroupAssetAdd",
        component: () => import("@/views/admin/pages/Group/AssetCreate"),
      },
      {
        path: "group/assetedit/:id/:GroupMemberId",
        name: "GroupAssetEdit",
        component: () => import("@/views/admin/pages/Group/AssetEdit"),
      },
      {
        path: "group/asset-view/:id/:GroupMemberId",
        name: "GroupAssetView",
        component: () => import("@/views/admin/pages/Group/AssetView"),
      },
      {
        path: "groupmember/vehicleinfocreate/:GroupMemberId",
        name: "GroupMemberVehicleInfo",
        component: () =>
          import("@/views/admin/pages/Group/VehicleInfoMemberCreate"),
      },
      {
        path: "group/vehicleinfocreate/:id",
        name: "GroupVehicleInfo",
        component: () => import("@/views/admin/pages/Group/VehicleInfoCreate"),
      },
      {
        path: "group/vehicleinfoedit/:id/:GroupMemberId",
        name: "GroupVehicleInfoEdit",
        component: () => import("@/views/admin/pages/Group/VehicleInfoEdit"),
      },
      {
        path: "group/vehicle-info-view/:id/:GroupMemberId",
        name: "GroupVehicleInfoView",
        component: () => import("@/views/admin/pages/Group/VehicleInfoView"),
      },
      {
        path: "/group/assignmotorpolicy/:id",
        name: "AssignMotorPolicy",
        component: () => import("@/views/admin/pages/Group/assignmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "/group/assignclientmotorpolicy/:id",
        name: "AssignClientMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Group/assignclientmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "/group/assignxmotorpolicy/:id",
        name: "AssignXMotorPolicy",
        component: () => import("@/views/admin/pages/Group/assignxmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "/group/assignclientxmotorpolicy/:id",
        name: "AssignClientXMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Group/assignclientxmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "otherlob",
        name: "OtherLobList",
        component: () => import("@/views/admin/pages/OtherLob/OtherLobList"),
      },
      {
        path: "otherlob/lobcreate",
        name: "OtherLobAdd",
        component: () => import("@/views/admin/pages/OtherLob/OtherLobCreate"),
      },
      {
        path: "otherlob/lobcreate/:OtherLobId",
        name: "OtherLobEdit",
        component: () => import("@/views/admin/pages/OtherLob/OtherLobEdit"),
      },
      {
        path: "otherlob/other-lob-view/:OtherLobId",
        name: "OtherLobView",
        component: () => import("@/views/admin/pages/OtherLob/OtherLobView"),
      },
      {
        path: "crmSetup",
        name: "CrmSetupList",
        component: () => import("@/views/admin/pages/CrmSetup/CrmSetupList"),
      },
      {
        path: "broker",
        name: "BrokerListing",
        component: () => import("@/views/admin/pages/Broker/Index"),
      },

      // ========================================= My Master Broker  Start =========================================
      {
        path: "brokerData",
        name: "BrokerNewListing",
        component: () => import("@/views/admin/pages/BrokerData/Index"),
      },
      {
        path: "brokerData/create",
        name: "BrokerDataAdd",
        component: () => import("@/views/admin/pages/BrokerData/Create"),
      },
      {
        path: "brokerData/edit/:id",
        name: "BrokerDataEdit",
        component: () => import("@/views/admin/pages/BrokerData/View"),
      },
      {
        path: "brokerData/view/:id",
        name: "BrokerDataView",
        component: () => import("@/views/admin/pages/BrokerData/ViewBroker"),
      },
      {
        path: "invoicedata",
        name: "InvoiceListing",
        component: () =>
          import("@/views/admin/pages/BrokerData/InvoiceListing"),
      },

      // ========================================= My Master Broker  End =========================================

      {
        path: "broker/bulkHistory",
        name: "BrokerListingBulkHistory",
        component: () => import("@/views/admin/pages/Broker/BulkHistory"),
      },
      {
        path: "broker/create",
        name: "BrokerAdd",
        component: () => import("@/views/admin/pages/Broker/Create"),
      },
      {
        path: "broker/create/:id",
        name: "BrokerEdit",
        component: () => import("@/views/admin/pages/Broker/View"),
      },
      {
        path: "broker/view/:id",
        name: "BrokerView",
        component: () => import("@/views/admin/pages/Broker/ViewBroker"),
      },
      {
        path: "health",
        name: "Health",
        component: () => import("@/views/admin/pages/XMotor/Index"),
      },
      {
        path: "XMotorPremiumSchedules/:id",
        name: "XMotorPremiumSchedules",
        component: () =>
          import("@/views/admin/pages/XMotor/XMotorPremiumSchedules"),
      },
      {
        path: "travel",
        name: "Travel",
        component: () => import("@/views/admin/pages/XMotor/travel"),
      },
      {
        path: "nonmotor",
        name: "NonMotor",
        component: () => import("@/views/admin/pages/XMotor/nonmotor"),
      },
      {
        path: "life",
        name: "Life",
        component: () => import("@/views/admin/pages/XMotor/life"),
      },
      {
        path: "other",
        name: "Other",
        component: () => import("@/views/admin/pages/XMotor/other"),
      },
      {
        path: "agentledger",
        name: "AgentLedger",
        component: () => import("@/views/admin/pages/Ledger/Agent"),
      },
      {
        path: "brokerledger",
        name: "BrokerLedger",
        component: () => import("@/views/admin/pages/Ledger/Broker"),
      },
      {
        path: "groupledger",
        name: "GroupLedger",
        component: () => import("@/views/admin/pages/Ledger/Group"),
      },
      {
        path: "clientledger",
        name: "ClientLedger",
        component: () => import("@/views/admin/pages/Ledger/Client"),
      },
      {
        path: "agentTDSledger",
        name: "TDSAgentLedger",
        component: () => import("@/views/admin/pages/Ledger/TDS/Agent"),
      },
      {
        path: "brokerTDSledger",
        name: "TDSBrokerLedger",
        component: () => import("@/views/admin/pages/Ledger/TDS/Broker"),
      },
      {
        path: "TDSledger/:id",
        name: "LedgerTDSView",
        component: () => import("@/views/admin/pages/Ledger/TDS/Ledgerview"),
      },
      {
        path: "customerledger",
        name: "CustomerLedger",
        component: () => import("@/views/admin/pages/Ledger/Customer"),
      },
      {
        path: "ledgerview/:id",
        name: "LedgerView",
        component: () => import("@/views/admin/pages/Ledger/Ledgerview"),
      },
      {
        path: "ledgergroupview/:id",
        name: "LedgerGroupView",
        component: () => import("@/views/admin/pages/Ledger/LedgerGroupView"),
      },
      {
        path: "ledgerclientview/:id",
        name: "LedgerClientView",
        component: () => import("@/views/admin/pages/Ledger/LedgerClientView"),
      },
      {
        path: "xmotor/create",
        name: "XMotorAdd",
        component: () => import("@/views/admin/pages/XMotor/Create"),
      },
      {
        path: "xmotor/upload",
        name: "XMotorUpload",
        component: () => import("@/views/admin/pages/XMotor/Upload"),
      },
      {
        path: "xmotor/new-upload",
        name: "XMotorNewUpload",
        component: () => import("@/views/admin/pages/XMotor/NewUpload"),
      },
      {
        path: "xmotor/torenewal/:id",
        name: "RenewalToXmotor",
        component: () => import("@/views/admin/pages/Renewal/xmotortorenewal"),
      },
      {
        path: "xmotor/viewmore/:id",
        name: "XMotorViewMore",
        component: () => import("@/views/admin/pages/XMotor/viewmore"),
      },
      {
        path: "xmotor/view/:id",
        name: "XMotorView",
        component: () => import("@/views/admin/pages/XMotor/View"),
      },
      {
        path: "policyreports",
        name: "PolicyReports",
        component: () => import("@/views/admin/pages/Reports/Index"),
      },
      {
        path: "xmotorpolicyreports",
        name: "XMotorPolicyReports",
        component: () => import("@/views/admin/pages/Reports/XMotorIndex"),
      },
      {
        path: "xmotorpolicynewreports",
        name: "XMotorPolicyNewReports",
        component: () => import("@/views/admin/pages/Reports/XMotorNewIndex"),
      },
      {
        path: "renewalreports",
        name: "RENEWALReports",
        component: () => import("@/views/admin/pages/Reports/RenewalIndex"),
      },
      {
        path: "leadreports",
        name: "LeadReports",
        component: () => import("@/views/admin/pages/Reports/LeadIndex"),
      },
      {
        path: "outstandingReportsAgentBroker",
        name: "OutstandingReportsAgentBroker",
        component: () =>
          import("@/views/admin/pages/Reports/OutstandingReportsAgentBroker"),
      },
      {
        path: "outstandingReportsBanks",
        name: "OutstandingReportsBanks",
        component: () =>
          import("@/views/admin/pages/Reports/OutstandingReportsBanks"),
      },
      {
        path: "banner",
        name: "Banner",
        component: () => import("@/views/admin/pages/Banner/Index"),
      },
      {
        path: "renewal",
        name: "RenewalListing",
        component: () => import("@/views/admin/pages/Renewal/Index"),
      },
      {
        path: "renewal/lead",
        name: "RenewalLead",
        component: () => import("@/views/admin/pages/Renewal/Lead"),
      },
      {
        path: "renewal/health",
        name: "RenewalHealth",
        component: () => import("@/views/admin/pages/Renewal/Health"),
      },
      {
        path: "renewal/travel",
        name: "RenewalTravel",
        component: () => import("@/views/admin/pages/Renewal/Travel"),
      },
      {
        path: "renewal/nonMotor",
        name: "RenewalNonMotor",
        component: () => import("@/views/admin/pages/Renewal/NonMotor"),
      },
      {
        path: "renewal/life",
        name: "RenewalLife",
        component: () => import("@/views/admin/pages/Renewal/Life"),
      },
      {
        path: "renewal/other",
        name: "RenewalOther",
        component: () => import("@/views/admin/pages/Renewal/Other"),
      },
      {
        path: "premiumduelife",
        name: "LifePremiumDue",
        component: () => import("@/views/admin/pages/Renewal/LifePremiumDue"),
      },
      {
        path: "premiumdue/life",
        name: "PremiumDueLife",
        component: () => import("@/views/admin/pages/Renewal/PremiumDueLife"),
      },
      {
        path: "business/torenewal/:id",
        name: "BusinessToRenewal",
        component: () =>
          import("@/views/admin/pages/Renewal/businesstorenewal"),
      },
      {
        path: "my-earning",
        name: "MyEarning",
        component: () => import("@/views/admin/pages/Earning/Index"),
      },
      {
        path: "my-xm-earning",
        name: "MyXMEarning",
        component: () => import("@/views/admin/pages/Earning/XMIndex"),
      },
      {
        path: "my-new-earning",
        name: "NewEarning",
        component: () => import("@/views/admin/pages/Earning/NewIndex"),
      },
      {
        path: "verify-earning-commission",
        name: "VerifyCommission",
        component: () =>
          import("@/views/admin/pages/Earning/VerifyCommissionIndex"),
      },
      {
        path: "verify-earning-new-commission",
        name: "VerifyCommissionNew",
        component: () =>
          import("@/views/admin/pages/Earning/VerifyCommissionNewIndex"),
      },
      {
        path: "verify-new-earning-commission",
        name: "VerifyNewCommission",
        component: () =>
          import("@/views/admin/pages/Earning/VerifyNewCommissionIndex"),
      },
      {
        path: "bulk-commission-update",
        name: "BulkCommissionUpdate",
        component: () =>
          import("@/views/admin/pages/Earning/BulkCommissionUpdate"),
      },
      {
        path: "bulk-verify-commission-update",
        name: "BulkVerifyCommissionUpdate",
        component: () =>
          import("@/views/admin/pages/Earning/BulkVerifyCommissionUpdate"),
      },
      {
        path: "ledger-reconciliation",
        name: "LedgerReconciliation",
        component: () => import("@/views/admin/pages/Reconciliation/NewIndex"),
      },
      {
        path: "/manual-reconciliation",
        name: "ManualReconciliation",
        component: () =>
          import(
            "@/views/admin/pages/Ledger/NewLR/ManualReconciliationPage.vue"
          ),
        // meta: {
        //   title: "Manual Ledger Reconciliation",
        // },
      },
      {
        path: "/create-invoice",
        name: "CreateInvoice",
        component: () =>
          import("@/views/admin/pages/Ledger/NewLR/CreateInvoicePage.vue"),
        // meta: {
        //   // requiresAuth: true,
        //   title: "Create Invoice",
        // },
      },
      {
        path: "/bulk-reconciliation",
        name: "BulkLedgerReconciliation",
        component: () =>
          import(
            "@/views/admin/pages/Ledger/NewLR/BulkLedgerReconciliationPage.vue"
          ),
        // meta: {
        //   title: "Bulk Ledger Reconciliation",
        // },
      },

      {
        path: "ledgerReconciliation",
        name: "LedgerReconciliationNEW",
        component: () =>
          import("@/views/admin/pages/Reconciliation/LedgerReconciliationNEW"),
      },
      {
        path: "LedgerReconciliationViewEdit/:id/:type",
        name: "LedgerReconciliationViewEdit",
        component: () =>
          import(
            "@/views/admin/pages/Reconciliation/LedgerReconciliationViewEdit"
          ),
      },
      {
        path: "cheque-reconciliation",
        name: "ChequeReconciliation",
        component: () =>
          import("@/views/admin/pages/Reconciliation/NewChequeIndex"),
      },
      {
        path: "ledger-reconciliation/agent/:id",
        name: "AgentLedgerDetails",
        component: () => import("@/views/admin/pages/Reconciliation/AgentView"),
      },
      {
        path: "ledger-reconciliation/broker/:id",
        name: "BrokerLedgerDetails",
        component: () =>
          import("@/views/admin/pages/Reconciliation/BrokerView"),
      },
      {
        path: "quotation",
        name: "QuotationListing",
        component: () => import("@/views/admin/pages/Quotation/Index"),
      },
      {
        path: "vehiclemaster",
        name: "VehicleMasterListing",
        component: () => import("@/views/admin/pages/VehicleMaster/Index"),
      },
      {
        path: "claimManager",
        name: "ClaimManagerListing",
        component: () => import("@/views/admin/pages/ClaimManager/Index"),
      },
      {
        path: "UploadsDocuments/:id",
        name: "UploadsDocuments",
        component: () =>
          import("@/views/admin/pages/ClaimManager/UploadsDocuments"),
      },
      {
        path: "claimManager/create",
        name: "ClaimManagerAdd",
        component: () => import("@/views/admin/pages/ClaimManager/Create"),
      },
      {
        path: "claimManager/view/:id",
        name: "ClaimManagerView",
        component: () => import("@/views/admin/pages/ClaimManager/View"),
      },
      {
        path: "claimManager/viewmore/:id",
        name: "claimManagerViewMore",
        component: () => import("@/views/admin/pages/ClaimManager/Viewmore"),
      },
      {
        path: "vehiclerenewalmaster",
        name: "VehicleMasterRenewalListing",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/Index"),
      },
      {
        path: "vehiclerenewalmasterPUCC",
        name: "VehicleMasterRenewalPUCC",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/PUCCIndex"),
      },
      {
        path: "vehiclerenewalmasterFitness",
        name: "VehicleMasterRenewalFitness",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/FitnessIndex"),
      },
      {
        path: "vehiclerenewalmasterStatePerimt",
        name: "VehicleMasterRenewalStatePerimt",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/StatePerimtIndex"),
      },
      {
        path: "vehiclerenewalmasterNationalPermit",
        name: "VehicleMasterRenewalNationalPermit",
        component: () =>
          import(
            "@/views/admin/pages/VehicleMaster/Renewal/NationalPermitIndex"
          ),
      },
      {
        path: "vehiclerenewalmasterDriving",
        name: "VehicleMasterRenewalDriving",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/DrivingIndex"),
      },
      {
        path: "vehiclerenewalmastertax",
        name: "VehicleMasterRenewalTax",
        component: () =>
          import("@/views/admin/pages/VehicleMaster/Renewal/TaxIndex"),
      },
      {
        path: "vehiclemaster/create",
        name: "VehicleMasterAdd",
        component: () => import("@/views/admin/pages/VehicleMaster/Create"),
      },
      {
        path: "vehiclemaster/view/:id",
        name: "VehicleMasterView",
        component: () => import("@/views/admin/pages/VehicleMaster/View"),
      },
      {
        path: "vehiclemaster/viewmore/:id",
        name: "VehicleMasterViewMore",
        component: () => import("@/views/admin/pages/VehicleMaster/Viewmore"),
      },
      {
        path: "quotation/create",
        name: "QuotationAdd",
        component: () => import("@/views/admin/pages/Quotation/Create"),
      },
      {
        path: "quotation/create/:id",
        name: "QuotationEdit",
        component: () => import("@/views/admin/pages/Quotation/Create"),
      },
      {
        path: "profile",
        name: "MyProfile",
        component: () => import("@/views/admin/pages/Profile/Index"),
      },
      {
        path: "createOwnSite",
        name: "CreateOwnSite",
        component: () => import("@/views/admin/pages/Createsite/Index"),
      },
      {
        path: "referralhistory",
        name: "ReferralHistory",
        component: () => import("@/views/admin/pages/Profile/referralhistory"),
      },
      {
        path: "profile/signature",
        name: "ProfileSignature",
        component: () => import("@/views/admin/pages/Profile/Signature"),
      },
      {
        path: "profile/userplan",
        name: "ProfileUserPlan",
        component: () => import("@/views/admin/pages/Profile/Userplan"),
      },
      {
        path: "profile/lead",
        name: "ProfileLeaad",
        component: () => import("@/views/admin/pages/Profile/Lead"),
      },
      {
        path: "profile/tax-details",
        name: "TAXDetails",
        component: () => import("@/views/admin/pages/Profile/TaxDetails"),
      },
      {
        path: "crmlisting",
        name: "CRMListing",
        component: () => import("@/views/admin/pages/CRMList/Index"),
      },
      {
        path: "crmcontact",
        name: "CRMContact",
        component: () => import("@/views/admin/pages/CRMList/CRMContact"),
      },
      {
        path: "CRMNewFollowUP",
        name: "CRMNewFollowUP",
        component: () => import("@/views/admin/pages/CRMList/CRMNewFollowUP"),
      },
      {
        path: "CRMNewOpenTask",
        name: "CRMNewOpenTask",
        component: () => import("@/views/admin/pages/CRMList/CRMNewOpenTask"),
      },
      {
        path: "crmfollowup",
        name: "CRMFollowUP",
        component: () => import("@/views/admin/pages/CRMList/FollowUP"),
      },
      {
        path: "crmopentask",
        name: "CRMOpenTask",
        component: () => import("@/views/admin/pages/CRMList/CRMOpenTask"),
      },
      {
        path: "contactgroup",
        name: "Contactgroup",
        component: () =>
          import("@/views/admin/pages/CRMList/Source/CRMContactCreate"),
      },
      {
        path: "crmcontactedit/:id",
        name: "CRMContactEdit",
        component: () =>
          import("@/views/admin/pages/CRMList/Source/CRMContactEdit"),
      },
      {
        path: "crmcontactview/:id",
        name: "CRMContactView",
        component: () =>
          import("@/views/admin/pages/CRMList/Source/CRMContactView"),
      },
      {
        path: "crmfollowupadd/:id",
        name: "CRMFollowupAdd",
        component: () =>
          import("@/views/admin/pages/CRMList/Followup/CRMFollowupAdd"),
      },
      {
        path: "crmfollowupleadrenewaladd/:id",
        name: "CRMFollowupLeadRenewalAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMFollowupLeadRenewalAdd"
          ),
      },
      {
        path: "leadautomanualfollowupadd/:id",
        name: "AutoManualLeadFollowupAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/AutoManualLeadFollowupAdd"
          ),
      },
      {
        path: "crmhistoryfollowupleadadd/:id",
        name: "CRMHistoryFollowupLeadAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMHistoryFollowupLeadAdd"
          ),
      },
      {
        path: "leadautomanualhistoryfollowupleadadd/:id",
        name: "LeadAutoManualHistoryFollowupLeadAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/LeadAutoManualHistoryFollowupLeadAdd"
          ),
      },
      {
        path: "crmfollowupMotorrenewaladd/:id",
        name: "CRMFollowupMotorRenewalAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMFollowupMotorRenewalAdd"
          ),
      },
      {
        path: "crmhistoryfollowupMotoradd/:id",
        name: "CRMHistoryFollowupMotorAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMHistoryFollowupMotorAdd"
          ),
      },
      {
        path: "crmfollowupXMotorrenewaladd/:id",
        name: "CRMFollowupXMotorRenewalAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMFollowupXMotorRenewalAdd"
          ),
      },
      {
        path: "crmhistoryfollowupXMotoradd/:id",
        name: "CRMHistoryFollowupXMotorAdd",
        component: () =>
          import(
            "@/views/admin/pages/CRMList/Followup/CRMHistoryFollowupXMotorAdd"
          ),
      },
      {
        path: "crmhistoryfollowupadd/:id",
        name: "CRMHistoryFollowupAdd",
        component: () =>
          import("@/views/admin/pages/CRMList/Followup/CRMHistoryFollowupAdd"),
      },
      {
        path: "crmfollowcontactedit/:id",
        name: "CRMFollowContactEdit",
        component: () =>
          import("@/views/admin/pages/CRMList/Followup/CRMFollowupEdit"),
      },
      {
        path: "crmfollowcontactview/:id",
        name: "CRMFollowContactView",
        component: () =>
          import("@/views/admin/pages/CRMList/Followup/CRMFollowupView"),
      },
      {
        path: "crmopenleadsrenewal",
        name: "CRMLeadRenewal",
        component: () => import("@/views/admin/pages/CRMList/CRMLeadRenewal"),
      },
      {
        path: "crmopenmotorrenewal",
        name: "CRMMotorRenewal",
        component: () => import("@/views/admin/pages/CRMList/CRMMotorRenewal"),
      },
      {
        path: "crmopenxmotorrenewal",
        name: "CRMXMotorRenewal",
        component: () => import("@/views/admin/pages/CRMList/CRMXMotorRenewal"),
      },
      {
        path: "crmopenleads",
        name: "CRMOpenLeads",
        component: () => import("@/views/admin/pages/CRMList/CRMOpenLeads"),
      },
      {
        path: "crmrenewal",
        name: "CRMRenewal",
        component: () => import("@/views/admin/pages/CRMList/CRMRenewal"),
      },
      {
        path: "employee",
        name: "EmployeeListing",
        component: () => import("@/views/admin/pages/Employee/Index"),
      },
      {
        path: "/employee/assignmotorpolicy/:id",
        name: "AssignEmployeeMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Employee/assignmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "/employee/assignxmotorpolicy/:id",
        name: "AssignEmployeeXMotorPolicy",
        component: () =>
          import("@/views/admin/pages/Employee/assignxmotorpolicy"),
        props: (route) => ({
          id: route.params.id,
          policyType: route.params.policyType,
        }),
      },
      {
        path: "employee/create",
        name: "EmployeeAdd",
        component: () => import("@/views/admin/pages/Employee/Create"),
      },
      {
        path: "employee/create/:id",
        name: "EmployeeEdit",
        component: () => import("@/views/admin/pages/Employee/View"),
      },
      {
        path: "employee/dataview/:id",
        name: "EmployeeDataView",
        component: () => import("@/views/admin/pages/Employee/ViewData"),
      },
      {
        path: "employee/access/:id",
        name: "EmployeeView",
        component: () => import("@/views/admin/pages/Employee/Access"),
      },
      // Task Management
      {
        path: "taskmanagement",
        name: "TaskManagementListing",
        component: () => import("@/views/admin/pages/TaskManagement/Index"),
      },
      {
        path: "task/create",
        name: "CreateTask",
        component: () => import("@/views/admin/pages/TaskManagement/Create"),
      },
      {
        path: "task/edit/:id",
        name: "EditTask",
        component: () => import("@/views/admin/pages/TaskManagement/Edit"),
      },
      {
        path: "task/view/:id",
        name: "ViewTask",
        component: () => import("@/views/admin/pages/TaskManagement/View"),
      },

      // EKO Testing API
      {
        path: "EKOTestingAPI",
        name: "EKOTestingAPI",
        component: () => import("@/views/admin/pages/EKOTestingAPI/Index"),
      },

      {
        path: "DigilockerCallback",
        name: "DigilockerCallback",
        component: () =>
          import("@/views/admin/pages/EKOTestingAPI/DigilockerCallback"),
      },

      // Vahan Testing API
      {
        path: "VahanTestingAPI",
        name: "VahanTestingAPI",
        component: () => import("@/views/admin/pages/VahanTestingAPI/Index"),
      },
    ],
  },
];
